/**
 * Combine any duplicates lines in the cart based on the id hash.
 *
 * @param {Cart} cart
 */
const combineDuplicateLines = (cart) => {
    let cartItems = cart.getItems();
    cartItems.forEach((item) => {
        // Find any duplicates matched by hash key.
        let duplicates = cartItems.filter((i) => {
            return item.getID() === i.getID();
        });
        if (duplicates.length > 1) {
            // If any duplicates of this line are found, add the quantity of the duplicate line to this line.
            // Note that the first entry in the `duplicates` array will be the line that should be kepts. Any additional
            // items are the duplicates.

            // Add up the total quantity from the line to be kept plus any duplicates.
            let quantity = 0;
            duplicates.forEach((duplicate, key) => {
                quantity += duplicate.quantity;
                // If this line is not the first in the duplicates array then it is a duplicate and should be removed.
                if (key !== 0) {
                    cart.removeItem(duplicate);
                }
            });
            item.setQuantity(quantity);
        }
    });
};

module.exports = {
    combineDuplicateLines,
};
